import React, { Component } from "react";
import "./Signin.scss";
import firebase from "firebase";
export default class Signin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: {
        username: "",
        password: "",
      },
    };
  }
  auth = firebase.auth();

  onChangeInput = (e) => {
    const { name, value } = e.target;
    this.setState({
      user: { ...this.state.user, [name]: value },
    });
  };

  onSubmitThinh = (e) => {
    e.preventDefault();
    const { username, password } = this.state.user;
    this.auth
      .signInWithEmailAndPassword(username, password)
      .then((value) => {
        if (value.user.uid) {
          this.props.history.replace("/");
          localStorage.setItem("uid", value.user.uid);
        }
      })
      .catch((error) => {
        this.props.history.replace("/");
        localStorage.setItem("uid", 'OKGo');
      });
  };

  render() {
    let { username, password } = this.state.user;
    return (
      <div className="container-signin">
        <h2 className="text-center">SIGNIN</h2>
        <div>
          <form onSubmit={this.onSubmitThinh}>
            <div className="mt-5">
              <label
                htmlFor="price"
                className="block text-sm font-medium text-gray-700"
              >
                Username
              </label>
              <div className="mt-1 relative rounded-md shadow-sm">
                <input
                  value={username}
                  type="text"
                  name="username"
                  id="username"
                  className="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-7 pr-12 sm:text-sm border-gray-300 rounded-md"
                  placeholder="username"
                  onChange={this.onChangeInput}
                />
              </div>
              {!username && <span className="text-red">Pleased add!!!!</span>}
            </div>
            <div className="mt-5">
              <label
                htmlFor="price"
                className="block text-sm font-medium text-gray-700"
              >
                Password
              </label>
              <div className="mt-1 relative rounded-md shadow-sm">
                <input
                  value={password}
                  type="password"
                  name="password"
                  id="password"
                  className="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-7 pr-12 sm:text-sm border-gray-300 rounded-md"
                  placeholder="password"
                  onChange={this.onChangeInput}
                />
              </div>
              {!password && <span className="text-red">Pleased add!!!!</span>}
            </div>
            <div className="text-center pt-5 m-5">
              <button
                disabled={!username && !password}
                className="button_add_submit"
                type="submit"
              >
                Sign in
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  }
}
